/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Registering_Job_ForInputs */

const en_registering_job_for = /** @type {(inputs: Registering_Job_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registering job for ${i?.language}`)
};

const fr_registering_job_for = /** @type {(inputs: Registering_Job_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enregistrement de la tâche pour ${i?.language}`)
};

const de_registering_job_for = /** @type {(inputs: Registering_Job_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auftrag für ${i?.language} wird registriert`)
};

const it_registering_job_for = /** @type {(inputs: Registering_Job_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registrazione del lavoro per ${i?.language}`)
};

const ru_registering_job_for = /** @type {(inputs: Registering_Job_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Регистрация вакансии для ${i?.language}`)
};

const es_registering_job_for = /** @type {(inputs: Registering_Job_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registrando trabajo para ${i?.language}`)
};

const zh_cn2_registering_job_for = /** @type {(inputs: Registering_Job_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在为${i?.language}注册职位`)
};

const ja_registering_job_for = /** @type {(inputs: Registering_Job_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.language} のジョブを登録しています`)
};

const hi_registering_job_for = /** @type {(inputs: Registering_Job_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.language} के लिए नौकरी पंजीकृत करना`)
};

const pt_pt2_registering_job_for = /** @type {(inputs: Registering_Job_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cadastrando vaga para ${i?.language}`)
};

/**
* | output |
* | --- |
* | "Registering job for {language}" |
*
* @param {Registering_Job_ForInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const registering_job_for = /** @type {((inputs: Registering_Job_ForInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registering_Job_ForInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_registering_job_for(inputs)
	if (locale === "de") return de_registering_job_for(inputs)
	if (locale === "it") return it_registering_job_for(inputs)
	if (locale === "ru") return ru_registering_job_for(inputs)
	if (locale === "es") return es_registering_job_for(inputs)
	if (locale === "zh-CN") return zh_cn2_registering_job_for(inputs)
	if (locale === "ja") return ja_registering_job_for(inputs)
	if (locale === "hi") return hi_registering_job_for(inputs)
	if (locale === "pt-PT") return pt_pt2_registering_job_for(inputs)
	return en_registering_job_for(inputs)
});